// src/features/agent-builder/components/teasers/FeatureTeaser.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import clsx from 'clsx';

interface FeatureTeaserProps {
  titleKey: string;
  descriptionKey: string;
  className?: string;
}

export const FeatureTeaser: React.FC<FeatureTeaserProps> = ({
  titleKey,
  descriptionKey,
  className,
}) => {
  const { t } = useTranslation('agentBuilder');

  return (
    <div
      className={clsx(
        'p-6 text-center border-2 border-black border-dashed rounded-xl bg-slate-50',
        className
      )}
    >
      <div className="flex justify-center items-center mb-3">
        <Sparkles className="w-8 h-8 text-yellow-500" />
      </div>
      <h3 className="text-lg font-semibold text-slate-800">{t(titleKey)}</h3>
      <p className="mt-1 text-sm text-slate-600">{t(descriptionKey)}</p>
    </div>
  );
};